import React, { FC } from "react";
import { Breadcrumbs as BreadCrumbs, Link, Typography } from "@mui/material";

type BreadcrumbsProps = {
  paths: string[];
  links?: string[];
};

const Breadcrumbs: FC<BreadcrumbsProps> = ({ paths, links }) => {
  const orgId = localStorage.getItem("orgId");
  return (
    <BreadCrumbs
      sx={{
        fontFamily: "roboto",
        paddingBottom: { xs: "18px", md: "30px" },
        color: "#6C757D",
      }}
    >
      {paths?.map((item, index) => {
        let link = links?.[index] || "#"; // Fallback to "#" if links is not provided
        if (link !== "#" && orgId) {
          link = `/${orgId}${link.startsWith("/") ? link : `/${link}`}`; // Prepend orgId
        }
        return (
          <Link
            key={index}
            href={link}
            fontSize={["10px", "12px", "14px"]}
            color={index === paths.length - 1 ? "#ED1C24" : "#6C757D"}
            underline="none"
          >
            {item}
          </Link>
        );
      })}
      <Typography />
    </BreadCrumbs>
  );
};

export default Breadcrumbs;
